import React from 'react';
// Icon
class IconCode extends React.Component {
  render() {
    return (
      <svg id="IconCode" className={ this.props.styleName } version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="50 -50 200 200" enableBackground="new 50 -50 200 200">
      <path d="M85.9,50l42.8-42.8h-21.4L64.5,50l42.8,42.8h21.4L85.9,50z M192.8,7.2h-21.4L214.1,50l-42.8,42.8h21.4L235.5,50L192.8,7.2z
         M155.3-14.1l-26.7,128.3h16l26.7-128.3C171.4-14.1,155.3-14.1,155.3-14.1z"/>
      </svg>
    );
  }
}

export default IconCode;